import { Action, any, async, fromJSX, loadingAsyncState, nothing, stateful } from "widgets-for-react";
import { getNews, NewsResponse } from "./newsOverviewApi";
import { NewsOverviewLayout } from "./newsOverviewLayout";
import { initialNewsResponse, initialState, NewsOverviewProps, NewsOverviewState, resultsClass } from "./newsOverviewState";

export const NewsOverview = (props: NewsOverviewProps) =>
  stateful<NewsOverviewState>()(s0 =>
    any<Action<NewsOverviewState>>()([
      fromJSX(setState => NewsOverviewLayout({
        ...s0,
        ...props,
        key: 'newsOverview',
        setPage: (page) => setState((s0 => ({
          ...s0,
          currentPage: page,
          newsLoader: loadingAsyncState(getNews(page, props.pageSize), previousNewsResponse(s0))
        })))
      })),
      async<NewsResponse>(nothing, { key: 'newsLoader' })(s0.newsLoader)
        .map(newsUpdater => s1 => {
          const newsLoader = newsUpdater(s1.newsLoader)
          if (newsLoader.kind == 'loaded') scrollResultsToTop()
          return { ...s1, newsLoader }
        })
    ]).map(a => a(s0))
  )(initialState(props)).run(_ => { })

const previousNewsResponse = (s0: NewsOverviewState) => 
  s0.newsLoader.kind == 'loading' || s0.newsLoader.kind == 'loaded'
    ? s0.newsLoader.value
    : initialNewsResponse

const scrollResultsToTop = () => document
  .getElementsByClassName(resultsClass)[0]
  .scrollIntoView({ behavior: "smooth" })